import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { GroupService } from 'src/app/api/departure/group.service';
import { SearchTransportComponent } from 'src/app/components/search-transport/search-transport.component';
import { SearchGuidesComponent } from 'src/app/components/search-guides/search-guides.component';
import { SearchTourComponent } from 'src/app/components/search-tour/search-tour.component';
declare var $: any;
import * as moment from 'moment';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { ToolsService } from 'src/app/utils/tools.service';
import SwalAlert from 'src/app/utils/swalalert';
import { constants } from 'src/app/constants';
import { GeneralService } from 'src/app/api/config/general.service';
import { RecordGuideExtendsComponent } from '../record-guide-extends/record-guide-extends.component';
import { RecordTransportExtendsComponent } from '../record-transport-extends/record-transport-extends.component';

@Component({
  selector: 'app-group-form',
  templateUrl: './group-form.component.html',
  styleUrls: ['./group-form.component.css']
})
export class GroupFormComponent implements OnInit {
  private thisComponent: GroupFormComponent;
  @ViewChild(SearchTransportComponent) SearchTransportComponent: any;
  @ViewChild(SearchGuidesComponent) SearchGuidesComponent: any;
  @ViewChild(SearchTourComponent) SearchTourComponent: any;
  @ViewChild(RecordGuideExtendsComponent) RecordGuideExtendsComponent: any;
  @ViewChild(RecordTransportExtendsComponent) RecordTransportExtendsComponent: any;
  
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables ====
  date_departure: any = moment().format('YYYY-MM-DD');
  selected: any = null;
  capacity: any = null;
  capacity_old: any = null;
  available: any = null;
  exceeded: any = null;

  transportSelected: any = null;
  guideSelected: any = null;
  tourSelected: any = null;
  bookings: any = [];
  tours_selecteds: any = [];
  workinggroups: any = [];
  // validations selected
  validation_transport: any = [];
  validation_guide: any = [];
  // tipo de servicio de vehiculo
  vehiclestours: any = [];

  is_booking_checked: boolean = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private groupService: GroupService,
    private bookingsService: BookingsService,
    private generalService: GeneralService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      transport_id: [null],
      guide_id: [null],
      tour_id: [null],
      workinggroup_id: [null],
      typevehicle_tour: [null],
      date_departure: [null],
      capacity_vehicle: [null],
      capacity_selected: [null],
      observations: [null],
      viatic_assigned: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    let component_ = this.thisComponent;
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    (<any>$('#date_departure')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true
      },
      function(chosen_date: any) {
        component_.date_departure = chosen_date.format('YYYY-MM-DD');
        setTimeout(() => {
          component_.SearchTourComponent.focused();
          component_.validateTransport(component_.transportSelected);
          component_.validateGuide(component_.guideSelected);
        }, 150);
      }
    );

    setTimeout(() => {
      this.SearchTransportComponent.focused();
      // (<any>$('#typevehicle_tour')).attr('disabled', true);
    }, 150);

    if (this.isEdit) {
      this.editData();
    }
    this.getVehicleTour();
    this.getWorkingGroup();
  }

  editData() {
    this.groupService.get(this.checkId).subscribe({
      next: (data: any) => {
        let book = data.data.book;
        let editbookings_ = data.data.tours_booking;
        let bookings_pending = data.data.bookings;
        this.item.patchValue({
          transport_id: book.transport_id,
          guide_id: book.guide_id,
          tour_id: book.tour_id,
          workinggroup_id: book.workinggroup_id,
          typevehicle_tour: book.typevehicle_tour,
          date_departure: book.date_departure,
          capacity_vehicle: book.capacity_vehicle,
          capacity_selected: book.capacity_selected,
          observations: book.observations,
          viatic_assigned: book.viatic_assigned
        });
        // this.bookings = bookings_;
        this.capacity = book.capacity_vehicle;
        this.selected = book.capacity_selected;
        this.date_departure = book.date_departure;

        // for (let index in editbookings_) {
        //   let shift_tour_obj = this.toolsService.searchObjById(
        //     editbookings_[index].shift_tour,
        //     constants.TOURISM.SHIFT_TOURS
        //   );
        //   let vehicle_tour_obj = this.toolsService.searchObjById(
        //     editbookings_[index].vehicle_tour,
        //     constants.TOURISM.VEHICLE_TOURS
        //   );
        //   editbookings_[index].shift_tour_content = shift_tour_obj;
        //   editbookings_[index].vehicle_tour_content = vehicle_tour_obj;
        //   this.bookings.push(editbookings_[index]);
        // }

        for (let index in editbookings_) {
          this.bookings.push(editbookings_[index].tours_booking);
        }
        // bookings ======
        this.is_booking_checked = true;
        for (let i in bookings_pending) {
          this.bookings.push(bookings_pending[i]);
        }

        this.selectedTransportSearch(book.transport_data);
        // this.selectedGuideSearch(book.guide_data);
        this.guideSelected = book.guide_data;
        this.tourSelected = book.tour_data;
        (<any>$('#date_departure')).attr('disabled', true);
        (<any>$('#workinggroup_id')).attr('disabled', true);
        // this.selectedTourSearch(book.tour_data);
        // set checked
        setTimeout(() => {
          // for (let index in editbookings_) {
          //   (<any>$('#booking_' + editbookings_[index].id)).attr(
          //     'checked',
          //     'checked'
          //   );
          //   this.tours_selecteds.push(editbookings_[index]);
          // }
          // nuevo formato de version
          for (let index in editbookings_) {
            (<any>$('#booking_' + editbookings_[index].tours_booking.id)).attr(
              'checked',
              'checked'
            );
            this.tours_selecteds.push(editbookings_[index].tours_booking);
          }
          (<any>$('#typevehicle_tour')).attr('disabled', true);
          this.calculateCapacity();
        }, 50);
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getWorkingGroup() {
    this.generalService.listWorkingGroup().subscribe({
      next: (data: any) => {
        this.workinggroups = data.results;
      }
    });
  }

  getVehicleTour() {
    this.generalService.listVehiclesTours().subscribe({
      next: (data: any) => {
        this.vehiclestours = data;
      }
    });
  }

  changeTypeVehicleTour(){
    if(this.tourSelected != null){
      this.selected = 0;
      this.available = null;
      this.exceeded = null;
      this.bookings = [];
      this.tours_selecteds = [];
      this.toursPending(this.tourSelected.id);
    }
    
  }

  selectedTransportSearch(item_: any) {
    this.transportSelected = item_;
    this.capacity = this.transportSelected.capacity;
    this.calculateCapacity();
    this.item.patchValue({
      transport_id: this.transportSelected.id
    });
    this.validateTransport(this.transportSelected);
    // (<any>$('#typevehicle_tour')).attr('disabled', false);
  }

  removeTransport() {
    this.transportSelected = null;
    this.capacity = null;
    this.available = null;
    this.exceeded = null;
    this.validation_transport = [];
    this.item.patchValue({
      transport_id: null,
    });
    setTimeout(() => {
      this.SearchTransportComponent.focused();
      // (<any>$('#typevehicle_tour')).attr('disabled', true);
    }, 150);
  }

  validateTransport(transport_: any) {
    if(!this.isEdit){
      if (transport_ != null) {
        let val_params =
          'date_departure=' +
          this.date_departure +
          '&transport_id=' +
          transport_.id;
        this.groupService.validateTransportGroup(val_params).subscribe({
          next: (data: any) => {
            this.validation_transport = data.data;
          }
        });
      }
    }
  }

  selectedGuideSearch(item_: any) {
    this.guideSelected = item_;
    this.item.patchValue({
      guide_id: this.guideSelected.id
    });
    this.validateGuide(this.guideSelected);
  }

  removeGuide() {
    this.guideSelected = null;
    this.validation_guide = [];
    this.item.patchValue({
      guide_id: null
    });
    setTimeout(() => {
      this.SearchGuidesComponent.focused();
    }, 150);
  }

  validateGuide(guide_: any) {
    if(!this.isEdit){
      if (guide_ != null) {
        let val_params =
          'date_departure=' +
          this.date_departure +
          '&guide_id=' +
          guide_.id;
        this.groupService.validateGuideGroup(val_params).subscribe({
          next: (data: any) => {
            this.validation_guide = data.data;
          }
        });
      }
    }
  }

  selectedTourSearch(item_: any) {
    (<any>$('#date_departure')).attr('disabled', true);
    (<any>$('#workinggroup_id')).attr('disabled', true);
    this.tours_selecteds = [];
    this.tourSelected = item_;
    this.item.patchValue({
      tour_id: this.tourSelected.id
    });
    this.toursPending(this.tourSelected.id);
  }

  removeTour() {
    this.tourSelected = null;
    this.selected = null;
    this.bookings = [];
    this.tours_selecteds = [];
    this.item.patchValue({
      tour_id: null
    });
    (<any>$('#date_departure')).attr('disabled', false);
    (<any>$('#workinggroup_id')).attr('disabled', false);
    setTimeout(() => {
      this.SearchTourComponent.focused();
    }, 150);
  }

  toursPending(tour_id: any) {
    let val_params =
      'date_departure=' +
      this.date_departure +
      '&tour_id=' +
      tour_id +
      '&workinggroup_id=' +
      this.item.value.workinggroup_id+
      '&typevehicle_tour=' +
      this.item.value.typevehicle_tour;
    this.bookingsService.toursPending(val_params).subscribe({
      next: (data: any) => {
        if (this.is_booking_checked) {
          let pendings_ = data.results;
          for (let index in pendings_) {
            this.bookings.push(pendings_[index]);
          }
        } else {
          this.bookings = data.results;
        }
      }
    });
  }

  selectedBooking(booking: any) {
    // console.log((<any>$('#booking_'+booking_id)).is(":checked"));
    // console.log(booking);
    let validate_ = this.toolsService.notExistObjInArr(
      booking,
      this.tours_selecteds
    );
    if (validate_) {
      this.tours_selecteds.push(booking);
      this.calculateCapacity();
    } else {
      let index = this.tours_selecteds.indexOf(booking);
      this.tours_selecteds.splice(index, 1);
      this.calculateCapacity();
    }
  }

  calculateCapacity() {
    this.selected = 0;
    if (this.tours_selecteds.length > 0) {
      for (let i in this.tours_selecteds) {
        this.selected = Number(this.selected) + Number(this.tours_selecteds[i].quantity);
      }

      if (!_.isNull(this.transportSelected)) {
        if (this.selected <= this.capacity) {
          this.available = Number(this.capacity) - Number(this.selected);
          this.exceeded = null;
        } else if (this.selected > this.capacity) {
          this.available = null;
          this.exceeded = Number(this.selected) - Number(this.capacity);
        }
      } else {
        // this.selected = null;
        this.available = null;
        this.exceeded = null;
      }
    } else {
      // this.selected = null;
      this.available = null;
      this.exceeded = null;
    }
  }

  revalidateSelected(){
    this.selected = 0;
    for (let i in this.tours_selecteds) {
      this.selected = Number(this.selected) + Number(this.tours_selecteds[i].quantity);
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    this.revalidateSelected();

    this.item.patchValue({
      date_departure: this.date_departure,
      capacity_vehicle: this.capacity,
      capacity_selected: this.selected
    });

    if (this.validate()) {
      let data: any = {};
      data.book = this.item.value;
      data.tours = this.tours_selecteds;
      if (this.isEdit) {
        this.groupService.update(this.checkId, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.groupService.save(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if (this.transportSelected == null) {
      this.alertifyMsg.warning('Debe seleccionar un Transporte para el grupo');
      this.SearchTransportComponent.focused();
      return false;
    }
    if (this.guideSelected == null) {
      this.alertifyMsg.warning(
        'Debe seleccionar un Guia de viaje para el grupo'
      );
      this.SearchGuidesComponent.focused();
      return false;
    }
    if (this.tours_selecteds.length == 0) {
      this.alert.msgWarning(
        'Debe seleccionar al menos una reserva para el grupo de pasajeros'
      );
      this.SearchTourComponent.focused();
      return false;
    }

    if (this.exceeded > 0) {
      this.alert.msgWarning(
        'No debes exceder el número de pasajeros al de la capacidad del transporte. EXCEDIDO: ' +
          this.exceeded
      );
      return false;
    }
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/salidas/grupos/lista']);
  }
}
